var _path, _path2;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgZikZakArrow = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 402,
    height: 83,
    viewBox: "0 0 402 83",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M401 83V83C401 52.0496 380.443 24.8648 350.663 16.4334L324.358 8.98591C304.259 3.29539 282.669 6.87863 265.486 18.7568L253.597 26.975C234.333 40.291 209.687 43.0923 187.927 34.4391L135.592 13.6277C114.145 5.09903 89.871 7.69991 70.7175 20.5788L53.8742 31.9044C39.2799 41.7177 20.0758 41.2285 5.99999 30.6848V30.6848",
    stroke: "#CCCCCC",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1704 19.6309L1.99963 28.5312L12.2317 52.8698",
    stroke: "#CCCCCC",
    strokeWidth: 2
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgZikZakArrow, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ZikZakArrow.4380af8d.svg";
export { ForwardRef as ReactComponent };